export default "__VITE_ASSET__273a6389__"